/**
 * Карточка/панель (rounded + тень) как в пазле/подборках. Стили из ui/tokens.
 */

export interface CardOptions {
  /** Внутренний padding (px), по умолчанию из токена */
  innerPaddingPx?: number;
  /** Зазор между детьми (px) */
  gapPx?: number;
}

/**
 * Создаёт контейнер-карточку с фоном, скруглением и тенью.
 * Возвращает { card, inner }: card — внешний div.ui-card, inner — div.ui-card-inner с padding и вертикальным стеком.
 */
export function createCard(options: CardOptions = {}): {
  card: HTMLElement;
  inner: HTMLElement;
} {
  const card = document.createElement('div');
  card.className = 'ui-card';

  const inner = document.createElement('div');
  inner.className = 'ui-card-inner';
  const padding = options.innerPaddingPx ?? undefined; // CSS var по умолчанию
  const gap = options.gapPx ?? undefined;
  if (padding != null) inner.style.padding = `${padding}px`;
  if (gap != null) inner.style.gap = `${gap}px`;

  card.appendChild(inner);
  return { card, inner };
}
